import { render, staticRenderFns } from "./OnboardingComplete.vue?vue&type=template&id=8d9cb886&scoped=true&"
import script from "./OnboardingComplete.vue?vue&type=script&lang=js&"
export * from "./OnboardingComplete.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingComplete.vue?vue&type=style&index=0&id=8d9cb886&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d9cb886",
  null
  
)

export default component.exports